import React from "react";
import { Tooltip } from "@mui/material";
import subOrganizationIcon from "../../assets/images/sub_organization_icon.png";

const SubOrganizationIcon = ({ size = 28, style }) => (
  <Tooltip title="Sub Organization" arrow>
    <span
      role="img"
      aria-label="Sub Organization"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 0,
        flexShrink: 0,
        ...style,
      }}
    >
      <img
        src={subOrganizationIcon}
        alt=""
        width={size}
        height={size}
        draggable={false}
        style={{ width: size, height: size, display: "block", objectFit: "contain" }}
      />
    </span>
  </Tooltip>
);

export default SubOrganizationIcon;
